import { Link } from "react-router-dom";
import { Search, ArrowRight } from "lucide-react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../ui/accordion";
import { useContent } from "../../context/ContentContext";

export default function FaqCta() {
  const { c } = useContent();
  const cta = c.ctaBand;
  const faqs = c.faqs || [];
  return (
    <>
      <section className="bg-[var(--navy)] py-16">
        <div className="mx-auto max-w-[1200px] px-5 text-center lg:px-8">
          <h2 className="font-display text-[30px] font-extrabold tracking-tight text-white sm:text-[38px]">{cta.title}</h2>
          <p className="mx-auto mt-4 max-w-2xl text-[16px] leading-relaxed text-slate-300">{cta.description}</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/providers" className="inline-flex items-center gap-2 rounded-xl bg-white px-6 py-3.5 text-[15px] font-semibold text-[var(--ink)] transition-colors hover:bg-slate-100">
              <Search size={17} /> {cta.primaryCta}
            </Link>
            <Link to="/compare" className="group inline-flex items-center gap-2 rounded-xl bg-[var(--brand-blue)] px-6 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-[var(--brand-blue-hover)]">
              {cta.secondaryCta}
              <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </section>

      <section className="bg-white py-20 lg:py-24">
        <div className="mx-auto max-w-[860px] px-5 lg:px-8">
          <div className="text-center">
            <p className="eyebrow">{c.faqHome.eyebrow}</p>
            <h2 className="font-display mt-3 text-[32px] font-extrabold tracking-tight text-[var(--ink)] sm:text-[40px]">{c.faqHome.title}</h2>
          </div>
          <Accordion type="single" collapsible className="mt-10 w-full">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-slate-200">
                <AccordionTrigger className="py-5 text-left text-[16px] font-semibold text-[var(--ink)] hover:no-underline">{f.q}</AccordionTrigger>
                <AccordionContent className="pb-5 text-[15px] leading-relaxed text-slate-500">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </>
  );
}
